import React from "react";
import { colors } from "../../../../../themes/Colors";
import { BaseButtons } from "../../../../common-components";

const KeyMovementNotice = ({ notice, onAcceptClick, onDeclineClick }) => {
  return (
    <div
      style={{
        height: 200,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          height: notice ? (notice.status === "ACCEPTED" ? 150 : 185) : 185,
          width: "95%",
          backgroundColor: colors.white,
          WebkitBoxShadow: "-5px 5px 15px -1px #00000030",
          overflow: "hidden",
          borderRadius: 8,
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <div
          style={{
            height: 40,
            width: "100%",
            textAlign: "left",
            backgroundColor: colors.greenDark,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              marginLeft: 15,
              fontWeight: "bold",
              fontSize: 18,
              color: colors.white,
            }}
          >
            {notice ? notice.type : "loading"}
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ textAlign: "left", width: "90%", marginTop: 10 }}>
            {notice
              ? notice.transferredBy.toLocaleUpperCase() +
                " " +
                "wants to transfer the keys for vehicle" +
                " " +
                notice.vehicleId +
                " " +
                "," +
                "this vehicle is owned by " +
                " " +
                notice.vehicleOwnerId
              : "loading"}
          </div>
        </div>

        <div
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            color: colors.white,
            fontSize: 14,
          }}
        >
          {notice ? notice.status : "loading"}
        </div>
      </div>
      {notice ? (
        notice.status === "ACCEPTED" ? null : (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              position: "absolute",
              bottom: -10,
            }}
          >
            <BaseButtons
              label={"DECLINE"}
              backgroundColor={colors.orangeDark}
              width={"40%"}
              borderRadius={8}
              onClick={onDeclineClick}
            />

            <BaseButtons
              label={"ACCEPT"}
              backgroundColor={colors.greenLight}
              width={"40%"}
              borderRadius={8}
              onClick={onAcceptClick}
            />
          </div>
        )
      ) : null}
    </div>
  );
};

export default KeyMovementNotice;
